<template>
  <div class="">
    <h2 class="wtitle" id="wtitle">
      {{article.title}}
    </h2>
    <div class="time">

      <span v-if="article.type == 1 || article.type==3">发布时间：{{article.fbsjShort}} &nbsp;&nbsp;来源：{{article.ssxqmc}}</span>
      <span v-else>发布时间：{{article.fbsjShort}} &nbsp;&nbsp;</span>


      <span class="fontsize-c">
        【
        <a href="javascript:;" @click="fontSize('bigger')">大</a>
        <a href="javascript:;" @click="fontSize('normal')">中</a>
        <a href="javascript:;" @click="fontSize('smaller')">小</a>
        】
      </span>
      <span class="print-b">
        <a href="javascript:;" class="print-article" v-print="printObj">
          <img src="../../../assets/img/print.png" alt="" class="ico">
          打印</a>
      </span>
      <div class="share" id="share">
        <div class="share-icon"></div>
        <div class="share-box" id="share-box">
          <a class="share-btn gwds_weixin" data-w="gwds_weixin" title="微信" @click="shareWx">&nbsp;</a>
          <a class="share-btn gwds_tsina" data-w="gwds_tsina" title="新浪微博" @click="shareWb">&nbsp;</a>

        </div>

      </div>
    </div>


    <p class="line"></p>
    <div class="content" id="printcontent"  :style="{ fontSize: fontsize + 'px' }" >
      <p class="">&nbsp;&nbsp;</p>
      <p v-html="article.content"></p>
      <div v-if="article.fileList && article.fileList.length > 0">
        <p>附件：</p>
        <ul>
          <li v-for="(item,index) in article.fileList" :key="item.index">
            <a :href="article.hts+item.fileurl">{{item.filename}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'wenzhang',
    components: {},
    data() {
      return {
        fontsizeStyle:{"font-size":"20px;"},
        fontsize:15,
        article: {},
        printObj: {
          id: "#printcontent",
          popTitle: "good print",
          extraCss: "https://www.google.com/css/css1.css, https://www.google.com/css/css2.css",
          extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
          beforeOpenCallback (vue) {
            vue.printLoading = true
            console.log('打开之前')
          },
          openCallback (vue) {
            vue.printLoading = false
            console.log('执行了打印')
          },
          closeCallback (vue) {
            console.log('关闭了打印工具')
          }
        },
        vshareConfig: {
          shareList: ['more',
            'tsina',
            'weixin'
          ],
          common: {
            //此处放置通用设置
          },
          share: [{
            //此处放置分享按钮设置
          }],
          slide: [
            //此处放置浮窗分享设置
          ],
          image: [
            //此处放置图片分享设置
          ],
          selectShare: [
            //此处放置划词分享设置
          ]
        }
      }
    },
    mounted() {
      //获取文章id
      this.articleId = this.$route.query.articleId;
      this.getArticle(this.articleId)
    },
    methods: {
      getArticle(id) {
        var that = this;
        that.$myHttp.post("findxq?id=" + id)
          .then(function(data) {
            console.log(data)
            if (data.status == "200") {
              that.article = data.data;
              that.printObj.popTitle = data.data.title;
            } else {
              alert("数据请求错误")
            }

          }).catch(function(error) {
            alert(error)
          })


      },
      shareWb() {
        var url = window.location.href;
        console.log(url);
        var href =
          'http://service.weibo.com/share/share.php?title='+this.article.title +' '+ url
        window.open(href, '_blank');
      },
      shareWx() {
        let {
          href
        } = this.$router.resolve({
          path: "Code", // 这里写的是要跳转的路由地址
          query: {
            url: window.location.href
          } // 这里写的是页面参数
        });
        //href = window.location.href ;
        window.open(href, '_blank');

      },
      fontSize(size) {
        if (size == 'bigger') {

            this.fontsize ++ ;
        }
        if (size == 'normal') {
            this.fontsize = 20 ;
        }
        if (size == 'smaller') {
          this.fontsize -- ;
        }
      }
    }
  };
</script>

<style scoped>
  .share-w {
    padding-bottom: 50px;
    display: flex;
    justify-content: right;
  }

  .wtitle {
    text-align: center;
    padding: 40px 0 20px;
    font-size: 22px;
    color: #444;
  }

  .time {
    text-align: center;
    font-size: 14px;
    color: #232323;
    position: relative;
  }

  .line {
    height: 1px;
    width: 100%;
    background: #9c9c9c;
    margin-top: 20px;
  }

  .content {
    padding-bottom: 100px;
  }

  .print-b {
    padding-left: 0px;
    margin-right: 20px;
  }

  .print-wrap {
    padding-bottom: 50px;
  }

  div#share {
    display: inline-block;
    position: absolute;
    margin-top: -2px;
    right: 0;
  }

  .share * {
    margin: 0;
    padding: 0;
    text-decoration: none;
  }

  ul,
  li {
    list-style: none;
  }

  .share-icon {
    display: inline-block;
    width: 14px;
    height: 24px;
    line-height: 24px;
    background: url(../../../assets/img/icon_16.jpg) no-repeat center;
    vertical-align: -25%;
    *float: left;
  }

  .share-box {
    display: inline-block;
    *margin-top: -4px;
  }

  .share-box a {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    background: url(../../../assets/img/share.png) no-repeat;
    margin-left: 7px;
    cursor: pointer;
  }

  .share-box a:hover {
    opacity: .8;
  }

  .share-box a.gwds_weixin {
    background-position: 0 -38px;
  }

  .share .gwds_more {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(../../../assets/img/icon_17.jpg) no-repeat 0 0;
    cursor: pointer;
    *background-position: left 8px;
  }
</style>



// WEBPACK FOOTER //
// src/views/front/components/wenzhang.vue